import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part2 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. INTENT */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            4. Intent
                        </h1>

                        <div className="alert alert-info">
                            An intent represents what the client is trying to achieve,
                            independent of how it is executed.
                        </div>

                        <h5 className="mt-4">Canonical Intents Explained</h5>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li>
                                    <strong>DISCOVERY</strong><br />
                                    Fetches metadata (banks, wallets, fields, limits).<br />
                                    <em>Example:</em> “Which banks can I send to in Nigeria?”
                                </li>

                                <li className="mt-3">
                                    <strong>FIELD_REQUIREMENTS</strong><br />
                                    Returns required and optional fields for a given corridor and rail.<br />
                                    <em>Example:</em> “What fields are mandatory for bank payouts to India?”
                                </li>

                                <li className="mt-3">
                                    <strong>VALIDATE_ACCOUNT</strong><br />
                                    Checks account existence or format.<br />
                                    <em>Example:</em> Validate IBAN or wallet number.
                                </li>

                                <li className="mt-3">
                                    <strong>FX_QUOTE</strong><br />
                                    Provides exchange rate, fees, and expiry.
                                </li>

                                <li className="mt-3">
                                    <strong>CREATE</strong><br />
                                    Creates a transaction but does not guarantee finality.
                                </li>

                                <li className="mt-3">
                                    <strong>CONFIRM / COMMIT</strong><br />
                                    Explicit confirmation step (where supported).
                                </li>

                                <li className="mt-3">
                                    <strong>STATUS</strong><br />
                                    Fetches the current transaction state.
                                </li>

                                <li className="mt-3">
                                    <strong>WEBHOOK_IN</strong><br />
                                    Asynchronous state updates from PSP.
                                </li>

                                <li className="mt-3">
                                    <strong>REFUND / REVERSAL / CHARGEBACK</strong><br />
                                    Post-execution financial adjustments.
                                </li>
                            </ul>
                        </div>

                        <div className="alert alert-warning mt-4">
                            Many PSPs collapse multiple intents into one API.
                            The canonical model separates them to retain control.
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 2. LIFECYCLE STATE MACHINE */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            5. Lifecycle State Machine
                        </h1>

                        <div className="alert alert-info">
                            A deterministic sequence of states that every transaction
                            must pass through.
                        </div>

                        <h5 className="mt-4">Core States</h5>

                        <div className="card p-3 bg-light border-0 mt-3">
                            <div className="row text-center doc-page">
                                <div className="col-md-3 mb-2"><strong>created</strong></div>
                                <div className="col-md-3 mb-2"><strong>validated</strong></div>
                                <div className="col-md-3 mb-2"><strong>quoted</strong></div>
                                <div className="col-md-3 mb-2"><strong>authorized</strong></div>
                                <div className="col-md-3 mb-2"><strong>submitted</strong></div>
                                <div className="col-md-3 mb-2"><strong>pending</strong></div>
                                <div className="col-md-3 mb-2"><strong>completed</strong></div>
                            </div>
                        </div>

                        <h5 className="mt-5">Terminal States</h5>

                        <div className="card p-3 bg-light border-0 mt-3">
                            <div className="row text-center doc-page">
                                <div className="col-md-3 mb-2"><strong>rejected</strong></div>
                                <div className="col-md-3 mb-2"><strong>failed</strong></div>
                                <div className="col-md-3 mb-2"><strong>cancelled</strong></div>
                                <div className="col-md-3 mb-2"><strong>expired</strong></div>
                                <div className="col-md-3 mb-2"><strong>reversed / refunded</strong></div>
                            </div>
                        </div>

                        <div className="alert alert-dark mt-4">
                            State transitions must be:
                            <ul className="mb-0 mt-2">
                                <li><strong>Monotonic</strong> (no backward jumps)</li>
                                <li><strong>Explainable</strong></li>
                                <li><strong>Auditable</strong></li>
                            </ul>
                        </div>

                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-one-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part I
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-three-doc">
                                                Part III &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>

                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}